import React, { Suspense, lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import ReactDOM from 'react-dom/client'

// Страницы грузятся отдельными чанками, чтобы глобальные стили лендинга и оферты не смешивались
const Landing = lazy(() => import('./landing/Landing'))
const MegaOfferts = lazy(() => import('./Components/megaOfferts/MegaOfferts').then((m) => ({ default: m.MegaOfferts })))

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<BrowserRouter>
	<React.StrictMode>
		<Suspense fallback={null}>
			<Routes>
				<Route path='/' element={<Landing />}/>
				<Route path='/offermega' element={<MegaOfferts/>}/>
			</Routes>
		</Suspense>
	</React.StrictMode>
  </BrowserRouter>,
)
